import { jsx as _jsx } from "react/jsx-runtime";
import { shallowEqual } from 'react-redux';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { ConversationHeaderCsatDropdown } from './components/csatDropdown/csatDropdown';
const messagesContainType = (messages, messageType) => messages.some(({ type }) => type === messageType);
function getCsatDisabledState(messages) {
    if (messagesContainType(messages, 'conversation:rated')) {
        return 'Answered';
    }
    if (messagesContainType(messages, 'conversation:rating_offered')) {
        return 'Offered';
    }
    if (messagesContainType(messages, 'conversation:rating_cancelled')) {
        return 'Cancelled';
    }
    return undefined;
}
export const ConversationHeaderCsatMenu = () => {
    const [{ isAssignedToMe, messages }, { initial_channel: channel, attributes }, asyncStatus,] = useAppSelector((state) => [
        state.conversation.metaConversation,
        state.conversation.metaConversation.conversation,
        state.conversation.asyncStatus,
    ], shallowEqual);
    const showSatisfactionLanguageDropdown = isAssignedToMe &&
        (attributes === null || attributes === void 0 ? void 0 : attributes.csat_eligible) === 'true' &&
        channel &&
        ['email', 'contactform', 'pstnphone', 'callback'].includes(channel);
    const isLoading = asyncStatus.getConversation === 'loading' ||
        asyncStatus.claim === 'loading' ||
        asyncStatus.close === 'loading';
    if (!showSatisfactionLanguageDropdown || isLoading) {
        return null;
    }
    const disabledText = getCsatDisabledState(messages);
    return _jsx(ConversationHeaderCsatDropdown, { disabledText: disabledText });
};
